import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let user = null;
  try {
    const stored = localStorage.getItem("user");
    if (stored && stored !== "undefined") user = JSON.parse(stored);
  } catch {
    user = null;
  }

  const token = localStorage.getItem("token");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("isAdmin");
    navigate("/login");
  };

  const handleSellClick = () => {
    if (!user || Number(user.licence_verified) !== 1 || user.verified_id !== "Y") {
      navigate("/verify-licence");
      return;
    }

    navigate("/select-category");
  };

  return (
    <header style={headerStyle}>
      <div style={brandStyle} onClick={() => navigate("/")}>
        Client Exchange<sup style={tmSymbol}>™</sup>
      </div>

      {/* DESKTOP NAV */}
      {!isMobile && (
        <nav style={desktopNavStyle}>
          <Link to="/" style={navLinkStyle}>
            Home
          </Link>

          {!token ? (
            <>
              <Link to="/login" style={navLinkStyle}>
                Login
              </Link>

              <Link to="/signup" style={signupButtonStyle}>
                Sign Up
              </Link>
            </>
          ) : (
            <>
              <button onClick={() => navigate("/dashboard")} style={navButtonStyle}>
                Dashboard
              </button>

              <button onClick={handleSellClick} style={sellButtonStyle}>
                Sell or Swap Clients
              </button>
            </>
          )}

          {isAdmin && (
            <Link to="/admin-console" style={navLinkStyle}>
              Admin Console
            </Link>
          )}

          {token && (
            <button onClick={handleLogout} style={logoutButtonStyle}>
              Logout
            </button>
          )}
        </nav>
      )}

      {/* MOBILE MAIN NAV - hamburger removed */}
      {isMobile && (
        <nav style={mobileMainNavStyle}>
          <Link to="/" style={mobileNavLinkStyle}>
            Home
          </Link>

          {token ? (
            <>
              <button onClick={() => navigate("/dashboard")} style={mobileNavButtonStyle}>
                Dashboard
              </button>

              <button onClick={handleSellClick} style={mobileSellButtonStyle}>
                Sell / Swap
              </button>

              {isAdmin && (
                <Link to="/admin-console" style={mobileNavLinkStyle}>
                  Admin
                </Link>
              )}

              <button onClick={handleLogout} style={mobileLogoutButtonStyle}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" style={mobileNavLinkStyle}>
                Login
              </Link>

              <Link to="/signup" style={mobileSignupButtonStyle}>
                Sign Up
              </Link>
            </>
          )}
        </nav>
      )}
    </header>
  );
}

/* ---------- STYLES ---------- */

const headerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: 1000,
  backgroundColor: "#2e7d32",
  color: "#fff",
  padding: "13px 14px",
  boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
};

const brandStyle = {
  fontSize: "1.05rem",
  fontWeight: "600",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const tmSymbol = {
  fontSize: "0.6rem",
  marginLeft: "2px",
  verticalAlign: "top",
};

const desktopNavStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap",
  justifyContent: "flex-end",
};

const mobileMainNavStyle = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  marginLeft: "auto",
  flexWrap: "wrap",
  justifyContent: "flex-end",
};

const navLinkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontWeight: "500",
  fontSize: "0.9rem",
  background: "none",
  border: "none",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const mobileNavLinkStyle = {
  ...navLinkStyle,
  fontSize: "0.78rem",
};

const navButtonStyle = {
  ...navLinkStyle,
  padding: 0,
};

const mobileNavButtonStyle = {
  ...mobileNavLinkStyle,
  padding: 0,
};

const signupButtonStyle = {
  backgroundColor: "#fff",
  color: "#2e7d32",
  padding: "6px 10px",
  borderRadius: "6px",
  fontWeight: "600",
  textDecoration: "none",
  whiteSpace: "nowrap",
};

const mobileSignupButtonStyle = {
  ...signupButtonStyle,
  padding: "5px 8px",
  fontSize: "0.78rem",
};

const sellButtonStyle = {
  backgroundColor: "#fff",
  color: "#2e7d32",
  padding: "6px 12px",
  borderRadius: "6px",
  border: "none",
  fontWeight: "700",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const mobileSellButtonStyle = {
  ...sellButtonStyle,
  padding: "5px 7px",
  fontSize: "0.76rem",
};

const logoutButtonStyle = {
  backgroundColor: "#d32f2f",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: "6px 10px",
  cursor: "pointer",
  fontWeight: "600",
};

const mobileLogoutButtonStyle = {
  ...logoutButtonStyle,
  padding: "5px 7px",
  fontSize: "0.76rem",
};

export default Header;
